import { JsEnv } from '../../../core/models/js_env';
import { RrRepository } from '../../../core/repositories/rr_repository';
import { getRrAreaData } from '../../../core/models/rr/rr_util';
import { CommonError } from '../models/common_error';
import { createRrRequestParam } from '../models/rr/set_rr_request';
import { CommonErrorContainer } from '../views/pc/common_error_container';

export class CommonErrorAction {
  private static state: CommonError;
  private static rrRepository: RrRepository;

  static init(env: JsEnv) {
    this.state = new CommonError(env.PAGE);
    this.rrRepository = new RrRepository();
    const model = this.state.getModel();

    if(model.shouldDisplayRecommend && window['RR'] !== undefined) { // おすすめ情報設定offの場合RR部分は実行しない

      // thisをCategoryMActionにbindしないとcallbackで渡しているのでrenderRr()中のthisがundefinedになってしまう
      window['RR'].jsonCallback = this.renderRr.bind(this);

      this.rrRepository.sendRequestToRrServer(createRrRequestParam(model));
    }
  }

  private static async renderRr() {

    const rrDataCommonError2 = await getRrAreaData(this.state.getModel().rrAreaProfileCommonError2)
    this.state.setRrAreaDataCommonError2(rrDataCommonError2.items, rrDataCommonError2.title);

    const rrDataCommonError3 = await getRrAreaData(this.state.getModel().rrAreaProfileCommonError3)
    this.state.setRrAreaDataCommonError3(rrDataCommonError3.items, rrDataCommonError3.title);

    return new CommonErrorContainer(this.state.getModel());
  }
}
